module.exports = __webpack_public_path__ + "static/media/word.cf02e461.svg";